import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Destinations from "@/components/Destinations";
import PackagesSection from "@/components/PackagesSection";
import WhyUs from "@/components/WhyUs";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import EnquiryDrawer from "@/components/EnquiryDrawer";
import { Reveal, Kicker } from "@/components/Reveal";
import { api, scrollToId } from "@/api";

export default function Home() {
  const [destinations, setDestinations] = useState([]);
  const [packages, setPackages] = useState([]);
  const [filter, setFilter] = useState({ destination: "All", duration: "any" });
  const [drawer, setDrawer] = useState({ open: false, pkg: null });
  const location = useLocation();

  useEffect(() => {
    api.get("/destinations").then((r) => setDestinations(r.data)).catch(() => {});
    api.get("/packages").then((r) => setPackages(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo && packages.length >= 0) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 150);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  const openEnquiry = (pkg = null) => setDrawer({ open: true, pkg });

  const handleDestinationSelect = (name) => {
    setFilter((f) => ({ ...f, destination: name }));
    scrollToId("packages");
  };

  return (
    <div data-testid="home-page">
      <Navbar onEnquire={() => openEnquiry()} />
      <Hero destinations={destinations} onSearch={handleDestinationSelect} onEnquire={() => openEnquiry()} />
      <EditorialMarquee />
      <Destinations destinations={destinations} onSelect={handleDestinationSelect} />
      <PackagesSection packages={packages} destinations={destinations} filter={filter} setFilter={setFilter} onEnquire={openEnquiry} />
      <WhyUs />
      <Testimonials />
      <section className="relative py-28 overflow-hidden grain" data-testid="cta-band">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.12),transparent_60%)]" />
        <Reveal className="relative max-w-3xl mx-auto px-6 text-center">
          <Kicker>Begin</Kicker>
          <h2 className="mt-4 font-serif text-3xl sm:text-5xl text-slate-50 tracking-tight">
            Your next story starts with <em className="gold-text not-italic">one conversation</em>
          </h2>
          <p className="mt-5 text-slate-400 text-sm sm:text-base">
            Tell us where your heart is pointing. We will compose the rest — flights, stays, transfers and every sunset in between.
          </p>
          <button onClick={() => openEnquiry()} data-testid="cta-enquire-btn"
            className="mt-9 rounded-full bg-gold px-10 py-4 text-sm font-semibold text-onyx-900 hover:bg-gold-light transition-colors">
            Talk to a travel designer
          </button>
        </Reveal>
      </section>
      <Footer />
      <EnquiryDrawer open={drawer.open} pkg={drawer.pkg} packages={packages} onClose={() => setDrawer({ open: false, pkg: null })} />
    </div>
  );
}
